module.exports = __webpack_public_path__ + "img/mail_ico.8f4d4c08.png";